import { createSvgIcon } from './createSvgIcon'

export default createSvgIcon(
  <>
    <path d="M3 18h18v-2H3zm0-5h18v-2H3zm0-7v2h18V6z"></path>
  </>,
  'Menu',
)
